<div class="row justify-content-center">
    <div class="col-xl-2"></div>
    <div class="col-xl-8">
        <div class="card" id="content" #content>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card-header border-bottom-dashed p-4">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <div *ngIf="invoiceData?.company_logo">
                                    <img src="{{invoiceData?.company_logo}}" class="card-logo card-logo-dark image-preview" alt="logo dark" height="120" width="220">
                                </div>
                                <div class="mt-sm-5 mt-4" *ngIf="invoiceData?.company_address?.address">
                                    <h6 class="text-muted text-uppercase fw-semibold">Address</h6>
                                    <p class="text-muted mb-1" id="address-details">{{invoiceData?.company_address?.address}}</p>
                                    <p class="text-muted mb-0" id="zip-code"><span>Zip-code:</span>{{invoiceData?.company_address?.pincode}}</p>
                                </div>
                                <div class="mt-sm-5 mt-2">
                                    <h6 class="text-muted text-uppercase fw-semibold">Customer</h6>
                                    <p class="text-muted mb-1" id="address-details">{{invoiceData?.customer_name}}</p>
                                </div>
                            </div>
                            <div class="flex-shrink-0 mt-sm-0 mt-3">
                                <h6 *ngIf="invoiceData?.legal_registration_number"><span class="text-muted fw-normal">Legal Registration No:</span><span id="legal-register-no">{{invoiceData?.legal_registration_number}}</span></h6>
                                <h6 *ngIf="invoiceData?.email"><span class="text-muted fw-normal">Email:</span><span id="email">{{invoiceData?.email}}</span></h6>
                                <h6 *ngIf="invoiceData?.website"><span class="text-muted fw-normal">Website:</span> <a class="link-primary" target="_blank" id="website">{{invoiceData?.website}}</a></h6>
                                <h6 *ngIf="invoiceData?.mobile" class="mb-0"><span class="text-muted fw-normal">Contact No: </span><span id="contact-no">{{invoiceData?.mobile}}</span></h6>
                                <h6 *ngIf="invoiceData?.subheading" class="mb-1"><span class="text-muted fw-normal">Sub Heading: </span><span id="contact-no">{{invoiceData?.subheading}}</span></h6>
                                <h6 *ngIf="invoiceData?.footer" class="mb-1"><span class="text-muted fw-normal">Footer: </span><span id="contact-no">{{invoiceData?.footer}}</span></h6>
                            </div>
                        </div>
                    </div>
                    <!--end card-header-->
                </div><!--end col-->
                <div class="col-lg-12">
                    <div class="card-body p-4" style="background: #fff;">
                        <div class="row g-3">
                            <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                                <h5 class="fs-14 mb-0"><span id="invoice-no">{{invoiceData?.invoice_number}}</span></h5>
                                <h5 class="fs-14 mb-0"><span id="invoice-no">{{invoiceData?.estimate_number}}</span></h5>
                            </div>
                            <!--end col-->
                            <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 class="fs-14 mb-0"><span id="invoice-date">{{invoiceData?.invoice_date|date:"medium"}}</span> <small class="text-muted" id="invoice-time"></small></h5>
                                <h5 class="fs-14 mb-0"><span id="invoice-date">{{invoiceData?.estimate_date|date:"medium"}}</span> <small class="text-muted" id="invoice-time"></small></h5>
                            </div>
                            <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                                <h5 class="fs-14 mb-0"><span id="invoice-date">{{invoiceData?.payment_due_date|date:"medium"}}</span> <small class="text-muted" id="invoice-time"></small></h5>
                                <h5 class="fs-14 mb-0"><span id="invoice-date">{{invoiceData?.expiry_date|date:"medium"}}</span> <small class="text-muted" id="invoice-time"></small></h5>
                            </div>
                            <!--end col-->
                            <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">P.O/S.O No</p>
                                <h5 class="fs-14 mb-0"><span id="invoice-no">{{invoiceData?.po_so_number}}</span></h5>
                            </div>
                            <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">Payment Status</p>
                                <span class="badge badge-soft-success fs-11" id="payment-status">{{invoiceData?.status}}</span>
                            </div>
                            <!--end col-->
                            <!-- <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">Total Amount</p>
                                <h5 class="fs-14 mb-0">$<span id="total-amount">{{invoiceData.payment_details.total_amount}}</span></h5>
                            </div> -->
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end card-body-->
                </div><!--end col-->
                <div class="col-lg-12">
                    <div class="card-body p-4 border-top border-top-dashed" style="background: #fff;">
                        <div class="row g-3">
                            <div class="col-6" *ngIf="invoiceData?.billing_address">
                                <h6 class="text-muted text-uppercase fw-semibold mb-3">Billing Address</h6>
                                <p class="fw-medium mb-2" id="billing-name">{{invoiceData?.billing_address?.name}}</p>
                                <p class="text-muted mb-1" id="billing-address-line-1">{{invoiceData?.billing_address?.address}}</p>
                                <p class="text-muted mb-1"><span>Phone: </span><span id="billing-phone-no">{{invoiceData?.billing_address?.mobile}}</span></p>
                                <p class="text-muted mb-0"><span>Tax: </span><span id="billing-tax-no">{{invoiceData?.billing_address?.tax_number}}</span> </p>
                            </div>
                            <!--end col-->
                            <div class="col-6" *ngIf="invoiceData?.shipping_address">
                                <h6 class="text-muted text-uppercase fw-semibold mb-3">Shipping Address</h6>
                                <p class="fw-medium mb-2" id="shipping-name">{{invoiceData?.shipping_address?.name}}</p>
                                <p class="text-muted mb-1" id="shipping-address-line-1">{{invoiceData?.shipping_address?.address}}</p>
                                <p class="text-muted mb-1"><span>Phone: </span><span id="shipping-phone-no">{{invoiceData?.shipping_address?.mobile}}</span></p>
                                <p class="text-muted mb-0"><span>Tax: </span><span id="shipping-tax-no">{{invoiceData?.shipping_address?.tax_number}}</span> </p>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end card-body-->
                </div><!--end col-->
                <div class="col-lg-12">
                    <div class="card-body p-4" style="background: #fff;">
                        <div class="table-responsive">
                            <table class="table table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                    <tr class="table-active">
                                        <th scope="col" style="width: 50px;">#</th>
                                        <th scope="col">Product Details</th>
                                        <th scope="col">Rate</th>
                                        <th scope="col">Quantity</th>
                                        <th scope="col">Tax</th>
                                        <th scope="col" class="text-end">Amount</th>
                                    </tr>
                                </thead>
                                <tbody id="products-list">
                                    <tr *ngFor="let data of invoiceData?.line_items; let i=index">
                                        <th scope="row">{{i+1}}</th>
                                        <td class="text-start">
                                            <span class="fw-medium">{{data.name}}</span>
                                            <!-- <p class="text-muted mb-0" style="max-width: 300px;">{{data.description}}</p> -->
                                        </td>
                                        <td>{{data.rate}}</td>
                                        <td>{{data.quantity}}</td>
                                        <td>{{data.tax}}</td>
                                        <td class="text-end">{{invoiceData.currency}}{{data.amount}}</td>
                                    </tr>
                                    
                                </tbody>
                            </table><!--end table-->
                        </div>
                        <div class="border-top border-top-dashed mt-2">
                            <table class="table table-borderless table-nowrap align-middle mb-0 ms-auto" style="width:250px">
                                <tbody>
                                    <tr>
                                        <td>Sub Total</td>
                                        <td class="text-end">{{invoiceData?.currency}}{{invoiceData?.payment_details?.sub_total}}</td>
                                    </tr>
                                    <tr>
                                        <td>Estimated Tax</td>
                                        <td class="text-end">{{invoiceData?.currency}}{{invoiceData?.payment_details?.tax}}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td>Discount <small class="text-muted">(VELZON15)</small></td>
                                        <td class="text-end">- {{invoiceData.payment_details.discount}}</td>
                                    </tr> -->
                                    <!-- <tr>
                                        <td>Shipping Charge</td>
                                        <td class="text-end">{{invoiceData.payment_details.shipping_charge}}</td>
                                    </tr> -->
                                    <tr class="border-top border-top-dashed fs-15">
                                        <th scope="row">Total Amount</th>
                                        <th class="text-end">{{invoiceData?.currency}}{{invoiceData?.payment_details?.total_amount}}</th>
                                    </tr>
                                </tbody>
                            </table>
                            <!--end table-->
                        </div>
                        <div class="mt-3" *ngIf="invoiceData?.payment_details">
                            <h6 class="text-muted text-uppercase fw-semibold mb-3">Payment Details:</h6>
                            <p class="text-muted mb-1">Payment Method: <span class="fw-medium" id="payment-method">{{invoiceData?.payment_details?.payment_method}}</span></p>
                            
                        </div>
                        <div class="mt-4">
                            <div class="alert alert-info">
                                <p class="mb-0"><span class="fw-semibold">NOTES:</span>
                                    <span id="note">All accounts are to be paid within 7 days from receipt of invoice. To be paid by cheque or
                                        credit card or direct payment online. If account is not paid within 7
                                        days the credits details supplied as confirmation of work undertaken
                                        will be charged the agreed quoted fee noted above.
                                    </span>
                                </p>
                            </div>
                        </div>
                       
                    </div>
                    <!--end card-body-->
                </div><!--end col-->
            </div><!--end row-->
        </div>
        <div class="hstack gap-2 justify-content-end d-print-none mt-4">
            <a href="javascript:window.print()" class="btn btn-primary"><i class="ri-printer-line align-bottom me-1"></i> Print</a>
            <button (click)="downloadPDF()" class="btn btn-primary">Download PDF</button>
        </div>
    </div>
    <div class="col-xl-2"></div>
</div>
<!--end row-->
